<template>
    <div class="modal" :class="{'is-active':active}">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Modal title</p>
                <button class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
            </section>
            <footer class="modal-card-foot">
                <button class="button is-danger" @click.prevent="active=false">Save changes</button>
                <button class="button">Cancel</button>
            </footer>
        </div>
    </div>
</template>
<script>
export default {
  props: ['active']
}
</script>

<style>
</style>
